import { AvailabilityAction } from './types'
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'

export const generateSuccessMessage = (
  name: string,
  action: AvailabilityAction
) => {
  switch (action) {
    case AvailabilityAction.UNSNOOZE:
      return `${name} is unsnoozed`
    case AvailabilityAction.SNOOZE:
      return `${name} is snoozed`
    case AvailabilityAction.IN_STOCK:
      return `${name} is marked as in stock`
    case AvailabilityAction.OUT_OF_STOCK:
      return `${name} is marked as out of stock`
  }
}

export const generateErrorMessage = (
  action: AvailabilityAction,
  error: any
) => {
  const isSnooze =
    action === AvailabilityAction.SNOOZE ||
    action === AvailabilityAction.UNSNOOZE

  if (isSnooze && error.message == 'no_schedule_available_for_day') {
    return 'Product/Modifier cannot be snoozed. There are no shifts available today during the locations opening hours'
  }

  return 'Changes cannot be made at this time.'
}

const padFigure = (figure: number) => figure.toString().padStart(2, '0')

export const getRemainingTime = (timestamp: string | null) => {
  if (isEmpty(timestamp)) return ''

  const offset = moment().utcOffset() / 60

  const given = moment().isDST()
    ? moment(timestamp).add(offset, 'hour')
    : moment(timestamp)

  const current = moment()

  const duration = moment.duration(given.diff(current))

  const totalHours = duration.hours() + duration.days() * 24

  return `${padFigure(totalHours)}:${padFigure(duration.minutes())}:${padFigure(
    duration.seconds()
  )}`
}

export const getAllOutOfStockGroups = (
  items: { in_stock: boolean; availability_group?: string | null }[]
) => {
  const groups = new Map<string, boolean>()
  items.forEach(({ in_stock, availability_group }) => {
    if (!availability_group) return
    if (in_stock) {
      groups.set(availability_group, false)
    } else if (!groups.has(availability_group)) {
      groups.set(availability_group, true)
    }
  })
  return new Set(
    [...groups.entries()].filter(([, allOos]) => allOos).map(([g]) => g)
  )
}

export const isItemSnoozed = (timestamp: string | null) => {
  if (isEmpty(timestamp)) return false

  const offset = moment().utcOffset() / 60

  const unsnoozeAt = moment().isDST()
    ? moment(timestamp).add(offset, 'hour')
    : moment(timestamp)

  const current = moment()

  return unsnoozeAt > current
}
